import { render } from "./CardSpecSelect.vue?vue&type=template&id=4d8b2e8f"
import script from "./CardSpecSelect.vue?vue&type=script&lang=js"
export * from "./CardSpecSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/CardSpecSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d8b2e8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d8b2e8f', __exports__)) {
    api.reload('4d8b2e8f', __exports__)
  }
  
  module.hot.accept("./CardSpecSelect.vue?vue&type=template&id=4d8b2e8f", () => {
    api.rerender('4d8b2e8f', render)
  })

}


export default __exports__